module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Gallery":"Für weitere Fotos hier klicken ➜"},"en":{"Gallery":"See more pictures ➜"},"hu":{"Gallery":"További képek megtekintése ➜"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/NewsArticle.vue
// module id = 373
// module chunks = 0